import { TComponentType } from '../types/bedev2Types';

type TTileDisplayConfig = {
  minTileWidth: number;
  columnGap: number;
  minTilesPerRow: number;
  maxTilesPerRow: number;
};

export const tileDisplayConfig: Record<TComponentType, TTileDisplayConfig> = {
  [TComponentType.GridTile]: {
    minTileWidth: 233,
    columnGap: 16,
    minTilesPerRow: 2,
    maxTilesPerRow: 6
  },
  [TComponentType.EventTile]: {
    minTileWidth: 233,
    columnGap: 16,
    minTilesPerRow: 4,
    maxTilesPerRow: 4
  },
  [TComponentType.InterestTile]: {
    // InterestTile has larger minTileWidth to increase tile sizes in the interest showcase modal
    minTileWidth: 311,
    columnGap: 16,
    minTilesPerRow: 2,
    maxTilesPerRow: 6
  },
  [TComponentType.AppGameTileNoMetadata]: {
    minTileWidth: 150,
    columnGap: 16,
    minTilesPerRow: 3,
    maxTilesPerRow: 12
  },
  [TComponentType.ExperienceEventsTile]: {
    minTileWidth: 233,
    columnGap: 16,
    minTilesPerRow: 2,
    maxTilesPerRow: 3
  }
};

export const defaultTileDisplayConfig: TTileDisplayConfig = {
  minTileWidth: 150,
  columnGap: 16,
  minTilesPerRow: 3,
  maxTilesPerRow: 12
};

export default {
  tileDisplayConfig,
  defaultTileDisplayConfig
};
